import { WithFeatures } from '@etrigan/feature-toggles'
import { isFeatureEnabled } from '@etrigan/feature-toggles-client'
import { useFeature } from '@news-mono/web-common'
import express from 'express'
import { debounce } from 'lodash'
import React, { useEffect, useRef } from 'react'
import { Logger } from 'typescript-log'
import { FallbackMessage } from '../FallbackMessage/FallbackMessage'
import { generateStatsWidgetHtml } from '../helpers/generateStateWidgetHtml'
import { postWidthToIframe } from '../helpers/postWidthToIframe'
import { OlympicWidgetWrap } from '../OlympicWidgetWrap/OlympicWidgetWrap'
import { StyledIframe } from '../OlympicWidgetWrap/OlympicWidgetWrap.styled'
import { StyledMedalTallyWrap } from './MedalTally.styled'

export interface MedalTallyProps {
    isFullSize: boolean
}

export const generateMedalWidget = (): express.Handler => {
    return async (
        req: express.Request & { log: Logger } & WithFeatures,
        res,
    ) => {
        if (
            !isFeatureEnabled(req.features, 'the-west-tokyo') &&
            !isFeatureEnabled(req.features, 'perthnow-tokyo')
        ) {
            return res.status(404).send()
        }

        req.log.debug({ req }, `medal widget requested`)

        res.set({
            'Content-Type': 'text/html',
        })

        return res.send(
            generateStatsWidgetHtml({
                id: 'shs-oly-olympic-medal-table',
                scriptId: 'oly-olympic-medal-table',
            }),
        )
    }
}

export function MedalTally(props: MedalTallyProps) {
    const { isFullSize } = props
    const iframe = useRef<HTMLIFrameElement | null>(null)
    const widgetWrap = useRef<HTMLDivElement | null>(null)
    const offset = 30

    const fallbackIsActive = useFeature('tokyo-medal-widget-fallback')
    const fallbackText =
        'There are currently no results to display at this time. Please check back soon'

    useEffect(() => {
        const iframePostWidthData = {
            iframeRef: iframe,
            containerRef: widgetWrap,
            offset: offset,
        }

        postWidthToIframe(iframePostWidthData)

        function handleResize() {
            postWidthToIframe(iframePostWidthData)
        }

        window.addEventListener('resize', debounce(handleResize, 50))

        return () => window.removeEventListener('resize', handleResize)
    }, [])

    return (
        <OlympicWidgetWrap isFullSize={isFullSize}>
            {fallbackIsActive ? (
                <FallbackMessage message={fallbackText} />
            ) : (
                <StyledMedalTallyWrap isFullSize={isFullSize} ref={widgetWrap}>
                    <StyledIframe
                        ref={iframe}
                        title="widget-iframe"
                        src="/olympic-wdg/medal-tally"
                    ></StyledIframe>
                </StyledMedalTallyWrap>
            )}
        </OlympicWidgetWrap>
    )
}
